import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Player from '@vimeo/player'
import { mobile } from '~styles/global'
import { getVimeoOptions } from '../utils/vimeo'
import { tablet } from '../styles/global'

const VimeoInline = ({ className, videoId, aspectRatio, showControls }) => {
	const [player, setPlayer] = useState()

	// Vimeo variables

	const videoContainer = useCallback((node) => {
		let options = getVimeoOptions(videoId, showControls)
		if (node) setPlayer(new Player(node, options))
	}, [])

	useEffect(() => {
		if (showControls) return
		setTimeout(() => {
			player?.play()
		}, 0)
	}, [player])

	return (
		<Wrap className={className}>
			<div>
				<div
					ref={videoContainer}
					css={css`
						position: relative;
						height: 0;
						overflow: hidden;
						max-width: 100%;
						width: 100%;
						transition: opacity 1s;
						padding-bottom: ${(1 / aspectRatio) * 100 + '%'};
						iframe{
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
						}
						iframe [data-sidedock=true] {
							opacity: 0;
						}
					}
			`}
				/>
			</div>
			<style>
				{`
					.videoFull {
						padding-left: 110px;
						padding-right: 110px;
						max-width: 1600px;
						width: auto;
						margin-bottom: 48px;

						${tablet} {
							padding-left: 93px;
							padding-right: 93px;
						}
						${mobile} {
							padding: 20px;
							margin-bottom: 14rem;
						}
					}
				`}
			</style>
		</Wrap>
	)
}

const Wrap = styled.div`
	position: relative;
	width: calc(100% - 40px);
	max-width: 1000px;
	margin: 0 auto;
	padding: 80px 40px;
	${mobile} {
		padding: 20px;
	}
`

VimeoInline.propTypes = {
	className: PropTypes.string,
	videoId: PropTypes.number,
	relativeHeight: PropTypes.bool,
	placeholder: PropTypes.object,
	aspectRatio: PropTypes.number,
	showControls: PropTypes.bool,
}

export default VimeoInline
